<template>
  <div class="center">
    <div class="crumb">
      小白资讯
      <span v-if="articleDetails.category_name"
        >/ {{ articleDetails.category_name }}</span
      >
    </div>
    <div class="article-title">{{ articleDetails.title }}</div>
    <div class="article-other">
      {{ articleDetails.writer_name }} 发布于 {{ articleDetails.release_time }}
    </div>
    <div class="article-content" v-html="articleDetails.content"></div>
  </div>
</template>

<script>
import { getArticleDetails } from '@/network/request'
export default {
  name: 'ArticleDetails',
  components: {},
  props: {},
  data() {
    return {
      articleId: this.$route.params.id || 0,
      articleDetails: {}, // 文章详情
    }
  },
  computed: {
    // 获取状态文字
    statusText() {
      return (status) => {
        return this.statusShowTexts[status]
      }
    },
  },
  watch: {},
  created() {
    console.info(this.articleId)
    this.getArticleDetails()
  },
  mounted() {},
  methods: {
    // 获取订单详情
    async getArticleDetails() {
      const { data } = await getArticleDetails({ id: this.articleId })
      this.articleDetails = data.result
      console.info(data.result)
      document.title = data.result.seo_title || data.result.title
    },
  },
}
</script>
<style lang="scss" scoped>
.center {
  width: 960px;
  margin: 30px auto;
  min-height: calc(100vh);
  border-radius: 12px;
  background-color: #ffffff;
  border: solid 1px #efefef;
  padding: 22px 28px;
}

.crumb {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #828282;
  height: 17px;
  line-height: 17px;
  margin-bottom: 15px;
}
.article-title {
  font-size: 32px;
  font-weight: bold;
  line-height: 1.35;
  margin-bottom: 14px;
}
.article-other {
  font-size: 14px;
  color: #666;
  line-height: 1.35;
}

::v-deep(.article-content) {
  margin-top: 30px;
  border-top: 1px solid #eee;
  padding-top: 30px;
  p,
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 10px 0;
    line-height: 1.5;
  }
}
</style>
